// assorted validation functions

// Validate Australian phone numbers
// (https://ilikekillnerds.com/2014/08/regular-expression-for-validating-australian-phone-numbers-including-landline-and-mobile/)
export const phoneRegexp = /^\(?((0|\+61) ?[24378])\)?[ -]?[0-9]{2}[ -]?[0-9]{2}[ -]?[0-9][ -]?[0-9]{3}$/;
